var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"country"},[_c('img',{staticClass:"flag",attrs:{"src":_vm.country.flag}}),_vm._v(_vm._s(_vm.country.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }